


export default function presentations(state = {
    presentationList: [], presentationView: {}, presentationCheck: false, singlePresentationCheck: false, presentationFilter: "filter|myPresentations", downloadCheck: false, connInfos: [],
    presentationsProgress: {}, isPresentationBigLoaded: false, tagsList: {}, presentationTagsFilter: {}, presentationSlideChanges: {}
}, action) {
    switch (action.type) {
        case 'LOAD_PRESENTATIONS':
            return {
                ...state, presentationList: (action.payload !== null) ? action.payload : [], presentationCheck: true, singlePresentationCheck: false, presentationSlideChanges: {},
            }
        case 'LOAD_PRESENTATION':
            const existingPresentationView = state["presentationView"]
            // If this presentation is already loaded, don't replace it with the version without slideImages. The one *with* the slideImages/sheetImages should "overrule" the version *without* slideImages/sheetImages.
            if (existingPresentationView.presentationID) {
                if (action.payload.presentationID === existingPresentationView.presentationID) {
                    if (typeof (action.payload.slides) !== "undefined") {
                        if (!action.payload.slides[0].slideImage) {
                            return {
                                ...state, presentationView: existingPresentationView
                            }
                        }
                    } else if (typeof (action.payload.sheets) !== "undefined") {

                        if (!action.payload.sheets[0].sheetImage) {
                            return {
                                ...state, presentationView: existingPresentationView
                            }
                        }
                    }
                }
            }
            return {
                ...state, presentationView: action.payload, presentationSlideChanges: {}
            }
        case 'SLIDE_CHANGES':
            return {
                ...state, presentationSlideChanges: action.payload
            }
        case 'LOGOUT_USER':
            return {
                ...state, presentationList: [], presentationView: {}, presentationCheck: false, singlePresentationCheck: false, presentationFilter: "filter|myPresentations", downloadCheck: false, connInfos: [], presentationsProgress: {}, presentationTagsFilter: {}, presentationSlideChanges: {}
            }
        case 'FLIP_PRESENTATIONS_SWITCH':
            return {
                ...state, presentationCheck: true,
            }
        case 'FLIP_SINGLE_PRESENTATION_SWITCH':
            return {
                ...state, singlePresentationCheck: true,
            }
        case 'APPLY_FILTER_PRESENTATIONS':
            return {
                ...state, presentationFilter: action.payload,
            }
        case 'LOAD_PRESENTATION_TAGS':
            return {
                ...state, tagsList: action.payload,
            }
        case 'APPLY_FILTER_PRESENTATIONS_TAGS':
            return {
                ...state, presentationTagsFilter: action.payload,
            }
        case 'DOWNLOAD_PRESENTATION_CHECK':
            return {
                ...state, downloadCheck: true,
            }
        case 'SET_CONNECTION_INFOS':
            return {
                ...state, connInfos: action.payload,
            }
        case 'CLEAR_PRESENTATION_VIEW':
            return {
                ...state, presentationView: {}, presentationSlideChanges: {},
            }
        case 'CLEAR_SLIDE_CHANGES_VIEW': 
            return {
                ...state, presentationSlideChanges: {},
            }
        case 'SHOW_PRESENTATIONS_PROGRESS':
            let hash = state["presentationsProgress"]
            hash[action.presID] = action.message
            return {
                ...state, presentationsProgress: hash, completedLoad: -1,
            }
        case 'CLEAR_PRESENTATION_PROGRESS':
            let hash2 = state["presentationsProgress"]
            delete hash2[action.presID]
            return {
                ...state, presentationsProgress: hash2, completedLoad: action.presID,
            }
        case 'SET_IS_PRESENTATION_BIG_LOADED':
            return {
                ...state, isPresentationBigLoaded: action.payload,
            }
        default:
            return state
    }
}